import { finish, error } from '../../../modules/customers/actions/find';

import api from '../../../api';

export function request(dispatch, { data }) {
    api.get('/customers', data, { cache: true }).then(
        (customers) => dispatch(finish(customers)),
        ({ errors }) => dispatch(error(errors))
    );
}
